import Vue from 'vue';
import VueMeta from 'vue-meta';

import light from '../themes/light';
import { cdn_url } from '../mixins/cdnUrl';

Vue.use(VueMeta, { refreshOnceOnNavigation: true });

export default {
  title: 'Dashboard',
  titleTemplate: 'CPlug Admin | %s',
  meta: [
    { name: 'theme-color', content: light['brand-lighten'] },
    { name: 'msapplication-navbutton-color', content: light['brand-lighten'] },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
  ],
  link: [
    { rel: 'icon', href: cdn_url('core/favicon.ico') },
  ],
};
